import { render } from "./PurchaseOrderApprovalList.vue?vue&type=template&id=d100358a&scoped=true"
import script from "./PurchaseOrderApprovalList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderApprovalList.vue?vue&type=script&lang=js"

import "./PurchaseOrderApprovalList.vue?vue&type=style&index=0&id=d100358a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d100358a"]])

export default __exports__